var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"default pa-0 background align-start",attrs:{"fluid":"","fill-height":""}},[_c('nuxt')],1)],1),_c('notification'),_c('dialogs',{ref:"dialogs"}),_c('snackbars'),_c('mobile-drawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }